import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { ReactNode, useMemo } from 'react';

import { OptimizelyFeatureFlags } from '@tgg/common-types';

import { createTggTheme } from '../../theme';
import { useFlagsContext } from '../flagsContext';

import { TggThemeContext } from './tggThemeContext';

export type TggThemeProperties = {
    children: ReactNode;
};

export function TggThemeProvider({ children }: TggThemeProperties) {
    const {
        flags: {
            [OptimizelyFeatureFlags.REBRANDING]: {
                enabled: isRebrandingEnabled,
                variationKey: rebrandingVariationKey,
            },
        },
    } = useFlagsContext();

    const theme = useMemo(
        () => createTggTheme(isRebrandingEnabled),
        [isRebrandingEnabled],
    );

    return (
        <TggThemeContext.Provider value={{ theme }}>
            <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
        </TggThemeContext.Provider>
    );
}
